module.exports = __webpack_public_path__ + "img/floor_EG.ef53ec44.svg";